import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Product from "@/pages/Product";
import Platform from "@/pages/Platform";
import Pillar from "@/pages/Pillar";
import Industry, { IndustriesIndex } from "@/pages/Industry";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import CrmLayout from "@/pages/crm/CrmLayout";
import Dashboard from "@/pages/crm/Dashboard";
import Contacts from "@/pages/crm/Contacts";
import Companies from "@/pages/crm/Companies";
import Deals from "@/pages/crm/Deals";
import ComingSoon from "@/pages/crm/ComingSoon";
import Settings from "@/pages/crm/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Marketing site */}
            <Route path="/" element={<Home />} />
            <Route path="/products/:slug" element={<Product />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/platform/:slug" element={<Pillar />} />
            <Route path="/industries" element={<IndustriesIndex />} />
            <Route path="/industries/:slug" element={<Industry />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* CRM (protected) */}
            <Route
              path="/app/crm"
              element={
                <ProtectedRoute>
                  <CrmLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="companies" element={<Companies />} />
              <Route path="deals" element={<Deals />} />
              <Route
                path="activities"
                element={
                  <ComingSoon
                    moduleKey="deal"
                    title="Activities"
                    labelOverride="Activities"
                    description="Tasks, notes, calls and meetings — with a calendar view."
                  />
                }
              />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="/app" element={<Navigate to="/app/crm" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
